import React from 'react';
import ProductDetail from '../components/ProductDetail';
  
function Detail() {  
  return (  
    <ProductDetail/>  
  );  
}  

export default Detail;